import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { axiosInstance } from '@/axiosConfig';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '@/components/ui/card';
import { toast } from 'sonner';
import { Rocket, Loader2, Check } from 'lucide-react';

export default function Register() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  
  // Estado para o Checkbox dos termos
  const [aceiteTermos, setAceiteTermos] = useState(false);
  
  const [formData, setFormData] = useState({
    nome_agencia: '',
    nome_admin: '',
    email_admin: '',
    telefone: '',
    password: '',
    confirm_password: ''
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.id]: e.target.value });
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    
    if (formData.password !== formData.confirm_password) {
      toast.error("As senhas não coincidem.");
      return;
    }

    if (formData.password.length < 6) {
      toast.error("A senha deve ter pelo menos 6 caracteres.");
      return;
    }

    // Validação do Checkbox
    if (!aceiteTermos) {
        toast.error("Você precisa aceitar os Termos de Uso para continuar.");
        return;
    }

    setLoading(true);
    try {
      await axiosInstance.post('/auth/signup-saas', {
        nome_agencia: formData.nome_agencia,
        nome_admin: formData.nome_admin,
        email_admin: formData.email_admin,
        telefone: formData.telefone,
        password: formData.password,
        termos_aceitos: true
      });

      toast.success("Conta criada! Verifique seu e-mail para ativar.");
      setTimeout(() => navigate('/login'), 5000);

    } catch (error) {
      console.error(error);
      toast.error(error.response?.data?.detail || "Erro ao criar conta.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}>
      <Card className="w-full max-w-md shadow-xl border-0">
        <CardHeader className="space-y-1 text-center">
          <div className="flex justify-center mb-4">
            <div className="h-12 w-12 bg-blue-100 text-blue-600 rounded-lg flex items-center justify-center">
              <Rocket className="h-6 w-6" />
            </div>
          </div>
          <CardTitle className="text-2xl font-bold text-gray-900">Crie sua conta Grátis</CardTitle>
          <CardDescription>
            Comece a gerenciar sua agência de viagens hoje mesmo.
          </CardDescription>
        </CardHeader>
        <form onSubmit={handleRegister}>
          <CardContent className="space-y-4">
            
            <div className="space-y-2">
              <Label htmlFor="nome_agencia">Nome da Agência</Label>
              <Input id="nome_agencia" placeholder="Ex: BlueSky Viagens" value={formData.nome_agencia} onChange={handleChange} required />
            </div>

            <div className="space-y-2">
              <Label htmlFor="nome_admin">Seu Nome</Label>
              <Input id="nome_admin" placeholder="Nome do administrador" value={formData.nome_admin} onChange={handleChange} required />
            </div>

            <div className="space-y-2">
              <Label htmlFor="email_admin">Email Profissional</Label>
              <Input id="email_admin" type="email" placeholder="voce@suaagencia.com" value={formData.email_admin} onChange={handleChange} required />
            </div>
            
            <div className="space-y-2">
              <Label htmlFor="telefone">Telefone / WhatsApp</Label>
              <Input id="telefone" placeholder="(00) 00000-0000" value={formData.telefone} onChange={handleChange} />
            </div>

            <div className="grid grid-cols-2 gap-4">
                <div className="space-y-2">
                <Label htmlFor="password">Senha</Label>
                <Input id="password" type="password" value={formData.password} onChange={handleChange} required />
                </div>
                <div className="space-y-2">
                <Label htmlFor="confirm_password">Confirmar</Label>
                <Input id="confirm_password" type="password" value={formData.confirm_password} onChange={handleChange} required />
                </div>
            </div>

            {/* Checkbox dos Termos (AGORA NO LUGAR CERTO) */}
            <div className="flex items-start space-x-2 pt-2">
                <input 
                    type="checkbox" 
                    id="termos" 
                    className="mt-1 h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500 cursor-pointer"
                    checked={aceiteTermos}
                    onChange={(e) => setAceiteTermos(e.target.checked)}
                />
                <label htmlFor="termos" className="text-sm text-gray-600 leading-tight cursor-pointer">
                    Li e concordo com os <Link to="/termos" target="_blank" className="text-blue-600 underline hover:text-blue-800">Termos de Uso</Link> e a Política de Privacidade.
                </label>
            </div>

            <div className="text-xs text-gray-500 bg-gray-50 p-3 rounded border mt-2">
                <div className="flex items-center gap-2 mb-1"><Check className="w-3 h-3 text-green-600"/> Acesso Imediato</div>
                <div className="flex items-center gap-2 mb-1"><Check className="w-3 h-3 text-green-600"/> Plano Free (1 Usuário)</div>
                <div className="flex items-center gap-2"><Check className="w-3 h-3 text-green-600"/> Sem cartão de crédito</div>
            </div>

          </CardContent>
          <CardFooter className="flex flex-col gap-4">
            <Button 
                className="w-full text-lg py-6 bg-blue-600 hover:bg-blue-700 transition-all" 
                type="submit" 
                disabled={loading}
            >
              {loading ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : "Criar Minha Agência"}
            </Button>
            <div className="text-center text-sm text-gray-500">
              Já tem uma conta?{" "}
              <Link to="/login" className="font-semibold text-blue-600 hover:underline">
                Fazer Login
              </Link>
            </div>
          </CardFooter>
        </form>
      </Card>
    </div>
  );
}